// Angular
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
// Material
import { SelectionModel } from "@angular/cdk/collections";
import { MatPaginator, MatSort, MatSnackBar } from "@angular/material";
// RXJS
import { debounceTime, distinctUntilChanged, tap, skip, take, delay } from "rxjs/operators";
import { fromEvent, merge, Observable, of, Subscription } from "rxjs";
// LODASH
import { each, find } from "lodash";
// NGRX
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../../core/reducers";

//services
import { LayoutUtilsService, MessageType, QueryParamsModel } from "../../../../core/_base/crud";

import { UnitRateModel } from "../../../../core/unitrate/unitrate.model";
import { UnitRateDeleted, UnitRatePageRequested } from "../../../../core/unitrate/unitrate.action";
import { UnitRateDataSource } from "../../../../core/unitrate/unitrate.datasource";
import { SubheaderService } from "../../../../core/_base/layout";
import { UnitRateService } from "../../../../core/unitrate/unitrate.service";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../../../environments/environment";
import { ServiceMenus } from "../../../../core/serviceMenu/serviceMenu"

@Component({
	selector: "kt-list-unitrate",
	templateUrl: "./list-unitrate.component.html",
	styleUrls: ["./list-unitrate.component.scss"],
})
export class ListUnitrateComponent implements OnInit, OnDestroy {
	file;
	dataSource: UnitRateDataSource;
	displayedColumns = ["unit_rate_name", "service_rate", "sinking_fund", "overstay_rate", "common_area", "iuran_anggota", "actions"];
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild("sort1", { static: true }) sort: MatSort;
	// Filter fields
	@ViewChild("searchInput", { static: true }) searchInput: ElementRef;
	lastQuery: QueryParamsModel;
	// Selection
	selection = new SelectionModel<UnitRateModel>(true, []);
	unitRateResult: UnitRateModel[] = [];
	data = localStorage.getItem("currentUser");
	dataUser = JSON.parse(this.data);
	role = this.dataUser.role;
	// Subscriptions
	private subscriptions: Subscription[] = [];
	constructor(private activatedRoute: ActivatedRoute, private store: Store<AppState>, private router: Router, private service: UnitRateService, private layoutUtilsService: LayoutUtilsService, private subheaderService: SubheaderService, private cdr: ChangeDetectorRef, private http: HttpClient, private modalService: NgbModal,
	private serviceMenus: ServiceMenus
	) {}

	ngOnInit() {
		const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		this.subscriptions.push(sortSubscription);
		this.serviceMenus.loadFeatureAccess("/rateunit").subscribe()

		/* Data load will be triggered in two cases:
		- when a pagination event occurs => this.paginator.page
		- when a sort event occurs => this.sort.sortChange
		**/
		const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadUnitRateList();
				})
			)
			.subscribe();
		this.subscriptions.push(paginatorSubscriptions);

		// Filtration, bind to searchInput
		const searchSubscription = fromEvent(this.searchInput.nativeElement, "keyup")
			.pipe(
				// tslint:disable-next-line:max-line-length
				debounceTime(150), // The user can type quite quickly in the input box, and that could trigger a lot of server requests. With this operator, we are limiting the amount of server requests emitted to a maximum of one every 150ms
				distinctUntilChanged(), // This operator will eliminate duplicate values
				tap(() => {
					this.paginator.pageIndex = 0;
					this.loadUnitRateList();
				})
			)
			.subscribe();
		this.subscriptions.push(searchSubscription);

		// Set title to page breadCrumbs
		this.subheaderService.setTitle("Unit Rate");

		// Init DataSource
		this.dataSource = new UnitRateDataSource(this.store);
		const entitiesSubscription = this.dataSource.entitySubject.pipe(skip(1), distinctUntilChanged()).subscribe((res) => {
			this.unitRateResult = res;
		});
		this.subscriptions.push(entitiesSubscription);

		this.loadUnitRateList();
	}

	filterConfiguration(): any {
		const filter: any = {};
		const searchText: string = this.searchInput.nativeElement.value.toLowerCase();

		filter.unit_rate_name = `${searchText}`;
		return filter;
	}

	loadUnitRateList() {
		this.selection.clear();
		const queryParams = new QueryParamsModel(this.filterConfiguration(), this.sort.direction, this.sort.active, this.paginator.pageIndex + 1, this.paginator.pageSize);
		this.store.dispatch(new UnitRatePageRequested({ page: queryParams }));
		this.selection.clear();
	}

	deleteUnitRate(_item: UnitRateModel) {
		// tslint:disable-next-line:variable-name
		const _title = "Unit Rate Delete";
		// tslint:disable-next-line:variable-name
		const _description = "Are you sure to permanently delete this unit rate?";
		const _waitDesciption = "Unit rate is deleting...";
		const _deleteMessage = `Unit rate has been deleted`;

		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			}
			this.store.dispatch(new UnitRateDeleted({ id: _item._id }));
			this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
		});
	}
	export() {
		this.service.exportExcel();
	}
	editUnitRate(id) {
		this.router.navigate(["edit", id], { relativeTo: this.activatedRoute });
	}
	viewUnitRate(id) {
		this.router.navigate(["view", id], { relativeTo: this.activatedRoute });
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sb) => sb.unsubscribe());
	}
}
